module.exports = __webpack_public_path__ + "static/media/snow.dd71f017.svg";